@let tip = tip$ | async;
@if (tip) {
    <section
        class="flex flex-1 items-center gap-x-16 rounded-2xl bg-surface-A p-16"
    >
        <interacta-image alt="" [classes]="'size-80'" [src]="tip.imageSrc" />
        <div class="flex flex-col items-start gap-y-4">
            <p class="typo-sm-bold">
                {{ tip.title | translate }}
            </p>
            <p class="typo-sm">
                {{ tip.description | translate }}
            </p>
            <button
                class="py-4 typo-xs-bold-uppercase text-text-primary"
                type="button"
                (click)="tipButtonClicked.emit()"
            >
                {{ tip.buttonLabel | translate }}
            </button>
        </div>
    </section>
}
